

























































import Vue from "vue";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';

export default Vue.extend({

  name: "AuthConfirmPasswordChange",
  props: {
    confirmationCode: {
      type: String,
    },
    username: {
      type: String,
    }
  },
  data() {
    return {
      error: '',
      password: '',
      rePassword: '',
      showPassword: false,
      showRePassword: false,
      passwordRules: {
        required: (value: any) => !!value || 'Required.',
        min: (v: string | any[]) => v.length >= 6 || 'Min 6 characters'
      },
      busy: false,
    }
  },
  computed: {
    passwordConfirmationRule() {
      return () => (this.password === this.rePassword) || 'Password must match'
    },
  },
  methods: {
    verify: function () {
      this.busy = true;
      Auth.forgotPasswordSubmit(this.username, this.confirmationCode, this.password)
        .then(() => {
          this.busy = false;
          AmplifyEventBus.$emit('authState', 'signIn');
        })
        .catch(e => {
          this.busy = false;
          this.setError(e);
        });
    },
    signIn: function () {
      this.error = '';
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    setError: function (e: any) {
      this.error = e.message || e;
    },
  }
});
